import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { useCreateKnowledgeDocument } from '@/models/knowledgeDocument'

type Props = {
  open: boolean
  folder?: string | null
  onOpenChange: (open: boolean) => void
  onCreated: (slug: string) => void
}

export function NewDocumentDialog({ open, folder = null, onOpenChange, onCreated }: Props) {
  const [title, setTitle] = useState('')
  const createMutation = useCreateKnowledgeDocument()

  function handleCreate() {
    const trimmed = title.trim()
    if (!trimmed || createMutation.isPending) return
    createMutation.mutate(
      { title: trimmed, folder },
      {
        onSuccess: (doc) => {
          setTitle('')
          onOpenChange(false)
          onCreated(doc.slug)
        },
      }
    )
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New knowledge document</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-sm font-medium">Title</label>
          <Input
            autoFocus
            value={title}
            placeholder="e.g. Claims FAQ"
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleCreate()
            }}
          />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleCreate}
            disabled={!title.trim() || createMutation.isPending}
            loading={createMutation.isPending ? 'Creating…' : undefined}
          >
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
